import { createJccSubscription, createPayPalSubscription, getCompany, sendNotificationEmail } from '../services/api';
import { shouldChargeGross } from '../utils/subscriptionBilling';
import {
  formatSubscriptionGross,
  formatSubscriptionNet,
  getSubscriptionPlans,
} from '../constants/subscriptionPlans';

const PLAN_NAMES = {
  base: 'Base Business Plan',
  standard: 'Standard Business Plan',
};

export const generateOrderId = () => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  const hash = Math.random().toString(36).substring(2, 8);
  return `${day}-${month}-${year}-${hash}`;
};

const loadOffer = async (restaurant, planKey, currencies, authenticatedFetch) => {
  const offer = getSubscriptionPlans(restaurant.currency, currencies);
  const plan = planKey === 'base' ? offer.base : offer.standard;
  const company = restaurant.registered_company_id
    ? await getCompany(restaurant.registered_company_id, authenticatedFetch)
    : null;
  return { offer, plan, chargeGross: shouldChargeGross(company), planName: PLAN_NAMES[planKey] };
};

export const sendBankTransferOrder = async ({
  user,
  restaurant,
  planKey,
  currencies,
  agentCode,
  authenticatedFetch,
}) => {
  const { offer, plan, chargeGross, planName } = await loadOffer(
    restaurant,
    planKey,
    currencies,
    authenticatedFetch,
  );
  const planPrice = formatSubscriptionNet(plan, offer.symbol);
  const totalWithVAT = formatSubscriptionGross(plan, offer.symbol);

  await sendNotificationEmail({
    service: 'ow-owner',
    template_name: 'subscription_payment.html',
    to_email: user.email,
    subject: 'Subscription Order Payment',
    context: {
      order_id: generateOrderId(),
      plan_name: planName,
      plan_price: planPrice,
      total: chargeGross ? totalWithVAT : planPrice,
      restaurant_name: restaurant.name,
      agent_code: agentCode.trim() || null,
    },
    cc_emails: ['support@ow-client.com'],
    bcc_emails: ['krzysztof.zak@ow-client.com'],
  }, authenticatedFetch);
};

export const startPayPalCheckout = async ({
  restaurant,
  email,
  planKey,
  currencies,
  authenticatedFetch,
}) => {
  const { offer, plan, chargeGross, planName } = await loadOffer(
    restaurant,
    planKey,
    currencies,
    authenticatedFetch,
  );
  const order = await createPayPalSubscription({
    amount: Math.round(Number(chargeGross ? plan.gross : plan.net) * 100),
    currency: offer.currency,
    description: `${planName} - ${restaurant.name}`,
    restaurant_id: restaurant.id,
    plan: planKey,
    customer_email: email || undefined,
    reference: `${restaurant.id}-${planKey}`,
    redirect_url: `${window.location.origin}/restaurant/payment-result?plan=${encodeURIComponent(planName)}`,
  }, authenticatedFetch);
  window.location.assign(order.checkout_url);
};

export const startJccCheckout = async ({
  restaurant,
  planKey,
  currencies,
  authenticatedFetch,
}) => {
  const { offer, plan, chargeGross, planName } = await loadOffer(
    restaurant,
    planKey,
    currencies,
    authenticatedFetch,
  );
  const order = await createJccSubscription({
    amount: Math.round(Number(chargeGross ? plan.gross : plan.net) * 100),
    currency: offer.currency,
    description: `${planName} - ${restaurant.name}`,
    restaurant_id: restaurant.id,
    plan: planKey,
    redirect_url: `${window.location.origin}/restaurant/payment-result?plan=${encodeURIComponent(planName)}`,
  }, authenticatedFetch);
  window.location.assign(order.checkout_url);
};
